import { render, staticRenderFns } from "./AddressFormNew.vue?vue&type=template&id=2bf7f032&scoped=true"
import script from "./AddressFormNew.vue?vue&type=script&lang=ts"
export * from "./AddressFormNew.vue?vue&type=script&lang=ts"
import style0 from "./AddressFormNew.vue?vue&type=style&index=0&id=2bf7f032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf7f032",
  null
  
)

export default component.exports